import React from 'react'
import {
  PhoneRegex,
  EmailRegex,
  DangerousRegex,
  DateRegex,
  roleNameRegex,
  firstNameRegex,
  lastNameRegex,
  positionRegex,
  numberWithDecimalOnlyRegex,
  fileNameRegex
} from './regex';
import settings from '/settings';
import { PLUS_SQUARE } from '/utils/svg.js';
import Cookie from 'js-cookie';
import _ from 'lodash';
import {getRealm} from '/utils/host';
import env from '/env';

export function randomString(length = 10) {
  // adopted from https://gist.github.com/6174/6062387
  return [...Array(length)].map(i => (~~(Math.random() * 36)).toString(36)).join('');
}

export const activeClass = (condition, className = 'active') => condition ? className : '';

export const blankValidator = (val, err = 'Required') => (val||"").trim().length ? '' : err;

export const maxValidator = (val,err= 'Exceeding the max limit.')=>{
  if(val > 9999){
    return err;
  }else{
    return ""
  }
}
export const xssValidator = (val, err = 'Code/scripts are not allowed') => {
  if (DangerousRegex.test(val)) return err;

  const matches = (val||"").substr(0, 6).match(/[\$\=\;]/g);
  return matches && matches.length > 1 ? err : '';
}
export const existsValidator = (val, err = '') => {
  if (settings.roles && settings.roles.findIndex(role => role.name.toLowerCase() === val.toLowerCase().trim()) > -1) {
    return err.length ? err : `${val} already exists. Please enter a different name.`
  }
  else {
    return ''
  }
}

export const numberWithDecimalValidator = (val, err='Invalid Number') => numberWithDecimalOnlyRegex.test(val) ? '' : err;

export const firstNameValidator = (val, err='Invalid first name format') => firstNameRegex.test(val) ? '' : err;

export const lastNameValidator = (val, err='Invalid last name format') => lastNameRegex.test(val) ? '' : err;

export const positionValidator = (val, err="Invalid position format") => positionRegex.test(val) ? '' : err;

export const emailValidator = (val, err = 'Invalid email format') => EmailRegex.test(val) ? '' : err;

export const phoneValidator = (val, err = 'Invalid phone format') => (val||"").length ? (PhoneRegex.test(val) ? '' : err) : '';

export const roleNameValidator = (val, err = 'Invalid name format') => roleNameRegex.test(val) ? '' : err;

export const roleLengthValidator = (val, err = "Role name is more than 50 characters") => {
  if(val.length > 50){
    return err
  }
  else{
    return ''
  }
}

export const numberOfMonthsValidator = (val, err = 'Number should be 1 - 12') => val >= 1 && val <= 12 ? '' : err;

export const dateValidator = (val, err='Invalid date format') => val.length && !DateRegex.test(val) ? err : '';

// https://stackoverflow.com/questions/38084396/lodash-title-case-uppercase-first-letter-of-every-word
export const titleCase = str => _.reduce(_.map(_.split(str, " "), _.capitalize), (a, b) => a + " " + b);

export const titleCaseWord = word => word.substr(0, 1).toUpperCase() + word.toLowerCase().substr(1);

export const gridLoadingTemplate = (msg = 'Loading your data. Please wait...') => `<div class="los-custom-loading">
<div class="loader"></div>
<div>${msg}</div>
</div>`;

export const NumberFormatter = (locale='en-US') => new Intl.NumberFormat(locale);

export const checkMaximumAmount = (value) => {
  return value && parseInt(value) <= 1000000000000 ;
}
export const separateWithCommas = num => typeof num === 'undefined' ? '' : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const formatSpreadingNumber = (value) => {
  var usdFormate = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      currency: 'USD',
      style: "decimal",
      maximumFractionDigits:2
  });
  if(value == '') return value
  let usdFormatedValue = usdFormate.format(value);
  if (usdFormatedValue.indexOf('-') !== -1) {
      return "(" + usdFormatedValue.replace('-', '') + ")";
  } else {
      return usdFormatedValue;
  }
}

// https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
export const getTextWidth = (text, font = `${settings.fontSize} ${settings.fontFamily}`) => {
  const canvas = document.createElement("canvas");
  const context = canvas && typeof canvas.getContext == 'function' && canvas.getContext ? canvas.getContext("2d") : undefined;
  if(context)
    context.font = font;
  const metrics = context && typeof context.measureText == 'function' && context.measureText(text) ? context.measureText(text) :{};
  return metrics.width || settings.fontSize * text.length;
}

export default {
  randomString
}

export const fileNameValidator = (val, err = 'Invalid file name format') => fileNameRegex.test(val) ? '' : err;

export const stageList = () => {
  return ["Approval Queue", "Booked", "Approved","Withdrawn","Declined"]
}

export const stageCompare = () => {
  return ["Approval Queue"]
}
export const getLocationLabel = (entityId) => {
  return (entityId.charAt(entityId.length - 1) || '').toUpperCase() == 'C'
    ? 'COMMERCIAL'
    : 'INDIVIDUAL';
};
export const plusButton = () => {
  return `<div>
            <button name="add-comments" class="spreading-launch-field-comments-btn specific-class-internal">
              ${PLUS_SQUARE} 
            </button>
          </div>`
}

/**
 * Method to remove all cookies
 */
 export const removeAllCookies = () => {
   const realm = getRealm();
   const path = window.location.hostname.split('.');
   const domain = path.length == 3 ? path.slice(1).join('.') : '';
   const allCookies = Cookie.get();
   
   const filteredCookies = Object.keys(allCookies).filter(cookie => {
     const cookieRealm = cookie.split('_')[0];
     const isRealmCookie = cookieRealm === realm;
     return isRealmCookie;
   });
   localStorage.removeItem('NAVIGATION_FIRST_TAB');
   const isDevEnv = env.APP_ENV === 'development';

   for (let cookieName of filteredCookies) {
     Cookie.remove(cookieName, { path: '/' });
     if (domain) {
       Cookie.remove(cookieName, { path: '/', domain: `.${domain}` });
     }
   }
   
   if (isDevEnv) {
    localStorage.removeItem(settings.getLocalTokenName());
  }
 }

  /**
 * Method to remove all cookies
 */

  /**
 * Method to remove all data dog cookies
 */

export const removeAllDataDogCookies = () => {
  const hostname = window.location.hostname;
  const hostnameParts = hostname.split('.');
  const rootDomain = hostnameParts.length >= 2 ? hostnameParts.slice(-2).join('.') : '';
  
  const allCookies = Cookie.get();
  const trackingCookiePrefixes = ['_dd_']; // DataDog cookies: _dd_s, _dd_l, _dd_r, etc.

  const filteredCookies = Object.keys(allCookies).filter(cookie => {
    const isTrackingCookie = trackingCookiePrefixes.some(prefix => cookie.startsWith(prefix));
    return isTrackingCookie;
  });

  // DataDog sets cookies on the exact hostname with path='/', SameSite=Strict
  for (let cookieName of filteredCookies) {
    // Primary: Remove with only path (no domain = current hostname, matches DataDog default)
    Cookie.remove(cookieName, { path: '/', sameSite: 'strict' });
    Cookie.remove(cookieName, { path: '/' });
    
    // Fallback: Try with explicit domain variations
    Cookie.remove(cookieName, { path: '/', domain: hostname, sameSite: 'strict' });
    Cookie.remove(cookieName, { path: '/', domain: hostname });
    
    if (rootDomain) {
      Cookie.remove(cookieName, { path: '/', domain: `.${rootDomain}`, sameSite: 'strict' });
      Cookie.remove(cookieName, { path: '/', domain: `.${rootDomain}` });
      Cookie.remove(cookieName, { path: '/', domain: rootDomain });
    }
  }
}

/**
* Method to remove all data dog cookies
*/


 
export const getLogoPath = ()=>{
  return window.location.origin + window.__LOS__logoRelativePath;
} 
 export const loadStatments = (store,s) =>{
    return <div className="lender-info">
    <div className="lender-part">
        <h6>{(store.info || {}).entityName || ''}</h6>
        <div className="print-statement-heading stress-statement-heading">
            {titleCase((store.info || {}).templateTypeName || '')} {'  '} 
            {s.label == "Stress Test" ? "Stress Test" :s.label}
           <span className="statement-label"> (Dollars displayed are actual)</span>
        </div>
        {s.label == "Stress Test" && <br/>}
    </div>
    <div className="logo-part">
        <div className="print-preview-logo">
       <img src={getLogoPath()}/>
        </div>
    </div>
</div>
  }